import { cva } from 'class-variance-authority';

export const textAreaVariants = cva(
  [
    'font-comp-badge-font-family',
    'font-comp-badge-font-weight',
    'text-font-comp-badge-font-size',
    'tracking-font-comp-badge-letter-spacing',
    'leading-font-comp-badge-line-height',
    'text-center',
    'cursor-default',
  ],
  {
    variants: {
      size: {
        tiny: 'px-spacing-comp-badge-tiny-text-area',
        medium: 'px-spacing-comp-badge-medium-text-area',
      },
      truncate: {
        true: 'truncate',
        false: '',
      },
    },
    defaultVariants: {
      size: 'medium',
      truncate: true,
    },
  },
);
